<template>
	<div class="inner-page cases">
		
		<div>
			<AppHead title="Case Search" />

			<PageHeader 
				title="Search Cases"
				:desc="`Searching for: <strong>${searchTerm}</strong>`"
				:showHelper="false"
				>
				<div class="search-bar" v-if="permissions.canSearchProjects">
					<input 
						type="text" 
						placeholder="Search for a case" 
						v-model="search"
						@keyup.enter="searchCases"
						/>
					<Button
						size="regular"
						color="black"
						icon="search"
						@click="searchCases"
						/>
				</div>
			</PageHeader>

			<div class="cases-list" v-if="cases && cases.length > 0">

				<div class="result-count">
					Your search returned {{ cases.length }} cases
				</div>
				
				<CaseOverviewRow 
					v-for="(theCase, index) in cases"
					:key="index"
					:thisCase="theCase"
					:caseID="theCase.hashid"
					:visibleCaseID="theCase.enquiry_number ? theCase.enquiry_number : theCase.hashid"
					:description="theCase.description"
					:steps="theCase.progress_stage"
					:commentCount="theCase.chat_count"
					:assignManager="permissions.canAssignProjectManager"
					:permissions="permissions"
					/>

			</div>
			<Placeholder v-else message="No cases were found which match your search term" />
						
		</div>

	
	</div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Subtitle from "@/Components/Subtitle"
import Placeholder from "@/Components/Placeholder"
import CaseOverviewRow from "@/Components/Cases/CaseOverviewRow"
import Button from "@/Components/Button"
import { Link } from '@inertiajs/inertia-vue3'

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Subtitle,
		Placeholder,
		CaseOverviewRow,
		Button,
		Link
	},
	layout: AppLayout,
	props: [
		'cases',
		'permissions',
		'searchTerm'
	],
	data: () => {
		return {
			search: ''
		}
	},
	methods: {
		searchCases(){
			if(this.search.length > 0){
				this.$inertia.get(`/cases/search/${encodeURIComponent(this.search)}`)
			}
		}
	},
	mounted(){
		// console.log('cases', this.cases)
		this.search = this.searchTerm
	}
};
</script>

<style lang="sass">

.cases
	.cases-list
		width: 100%
		margin-bottom: 70px

		&.archive
			opacity: 0.6

		.result-count
			width: 100%
			font-size: 14px
			font-weight: 400
			color: #7c7c7c
			line-height: 1.1
			margin-bottom: 20px
			

	.case-groups
		width: 100%
		display: grid
		grid-template-columns: repeat(auto-fit, minmax(380px, 1fr))
		grid-gap: 20px

		@media (max-width: 768px)
			grid-template-columns: repeat(auto-fit, minmax(270px, 1fr))

	.search-bar
		width: 100%
		display: flex
		justify-content: flex-start
		align-items: center
		// gap: 20px

		input
			width: 100%
			max-width: 300px
			height: 42px
			border: 1px solid rgba(#000,0.1)
			border-radius: 6px 0 0 6px
			padding: 0 20px
			font-size: 16px
			font-weight: 400
			font-family: 'Roboto', sans-serif
			color: #252525

			&::placeholder
				color: #777

		.button
			border-radius: 0 6px 6px 0

		

</style>